import { RootState } from 'store/configureStore';
import { RepaymentStrategyField } from '../../RepaymentStrategy';

const isLoading = (state: RootState) => {
  return (field: RepaymentStrategyField) => {};
};

export default isLoading;
